import { IModifyUser, ModifyUser } from "../user/modifyUser";

export interface IAppReportListItem {
    id: string;
    unitCode: string;
    code: string;
    comment: string;
    startDate: number;
    endDate: number;
    isRead: boolean;
    locked: boolean;
    canEdit: boolean;
    createUser: IModifyUser;
    modifyUser: IModifyUser;
    publishUser: IModifyUser;
    archiveUser: IModifyUser;
}

export class AppReportListItem implements IAppReportListItem {
    id: string;
    unitCode: string;
    code: string;
    comment: string;
    startDate: number;
    endDate: number;
    isRead: boolean;
    locked: boolean;
    canEdit: boolean;
    createUser: ModifyUser;
    modifyUser: ModifyUser;
    publishUser: ModifyUser;
    archiveUser: ModifyUser;

    constructor();
    constructor(obj: IAppReportListItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.unitCode = obj && obj.unitCode || "";
        this.code = obj && obj.code || "";
        this.comment = obj && obj.comment || "";
        this.startDate = obj && obj.startDate || 0;
        this.endDate = obj && obj.endDate || 0;
        this.isRead = obj && obj.isRead || false;
        this.locked = obj && obj.locked || false;
        this.canEdit = obj && obj.canEdit || false;
        this.createUser = new ModifyUser(obj ? obj.createUser : null);
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
        this.publishUser = obj?.publishUser ? new ModifyUser(obj.publishUser) : null;
        this.archiveUser = obj?.archiveUser ? new ModifyUser(obj.archiveUser) : null;
    }
}